import CommonHeader from "component/common/Header";
import CommonHeaderDesktop from "component/common/HeaderDesktop";
import CommonMultiGameController from "component/common/MultiGameController";
import CommonGameController from "component/common/GameController";
import CommonTabs from "component/common/Tabs";
import CommonModalHeader from "component/common/ModalHeader";

export { CommonHeader };
export { CommonHeaderDesktop };
export { CommonMultiGameController };
export { CommonGameController };
export { CommonTabs };
export { CommonModalHeader };

export default Object.assign({
  CommonHeader,
  CommonHeaderDesktop,
  CommonMultiGameController,
  CommonGameController,
  CommonTabs,
  CommonModalHeader,
});
